import React from 'react'

const DeleteIcon = ({ ...props }) => (
  <div {...props}>
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle opacity="0.8" cx="20" cy="20" r="20" fill="#EB5757" />
      <path
        d="M26.5625 12.5H23.125V11.875C23.125 10.8395 22.2855 10 21.25 10H18.75C17.7145 10 16.875 10.8395 16.875 11.875V12.5H13.4375C12.5746 12.5 11.875 13.1996 11.875 14.0625V15.3125C11.875 15.6577 12.1548 15.9375 12.5 15.9375H27.5C27.8452 15.9375 28.125 15.6577 28.125 15.3125V14.0625C28.125 13.1996 27.4254 12.5 26.5625 12.5ZM18.125 11.875C18.125 11.5305 18.4055 11.25 18.75 11.25H21.25C21.5945 11.25 21.875 11.5305 21.875 11.875V12.5H18.125V11.875Z"
        fill="white"
      />
      <path
        d="M13.0611 17.1875C12.9496 17.1875 12.8607 17.2807 12.866 17.3921L13.3816 28.2141C13.4293 29.2156 14.2519 30 15.2543 30H24.7457C25.748 30 26.5707 29.2156 26.6184 28.2141L27.134 17.3921C27.1393 17.2807 27.0504 17.1875 26.9389 17.1875H13.0611ZM22.5 18.75C22.5 18.4047 22.7797 18.125 23.125 18.125C23.4703 18.125 23.75 18.4047 23.75 18.75V26.875C23.75 27.2203 23.4703 27.5 23.125 27.5C22.7797 27.5 22.5 27.2203 22.5 26.875V18.75ZM19.375 18.75C19.375 18.4047 19.6547 18.125 20 18.125C20.3453 18.125 20.625 18.4047 20.625 18.75V26.875C20.625 27.2203 20.3453 27.5 20 27.5C19.6547 27.5 19.375 27.2203 19.375 26.875V18.75ZM16.25 18.75C16.25 18.4047 16.5297 18.125 16.875 18.125C17.2203 18.125 17.5 18.4047 17.5 18.75V26.875C17.5 27.2203 17.2203 27.5 16.875 27.5C16.5297 27.5 16.25 27.2203 16.25 26.875V18.75Z"
        fill="white"
      />
    </svg>
  </div>
)

export default DeleteIcon
